import type { Translations } from './pt-PT.js';

export const en: Translations = {
  // jobs
  'job.caixa': 'Cashier',
  'job.escritorio': 'Office worker',
  'job.gestor': 'Manager',
  'job.director': 'Director',
  'job.ceo': 'CEO',

  // actions
  'action.dormir': 'Sleep',
  'action.comer-em-casa': 'Eat at home',
  'action.estudar-em-casa': 'Study at home',
  'action.trabalhar': 'Work',
  'action.candidatar-se': 'Apply for job',
  'action.estudar': 'Study',
  'action.comprar-comida': 'Buy 5 meals',
  'action.comprar-fato': 'Buy suit',
  'action.beber': 'Drink at bar',
  'action.comer-no-bar': 'Eat at bar',
  'action.socializar': 'Socialize',

  // locations
  'location.casa': 'Home',
  'location.trabalho': 'Work',
  'location.escola': 'School',
  'location.loja': 'Store',
  'location.bar': 'Bar',

  // education levels (0..5)
  'education.0': 'no education',
  'education.1': 'primary',
  'education.2': 'secondary',
  'education.3': "bachelor's",
  'education.4': "master's",
  'education.5': 'doctorate',

  // weekdays
  'weekday.seg': 'mon',
  'weekday.ter': 'tue',
  'weekday.qua': 'wed',
  'weekday.qui': 'thu',
  'weekday.sex': 'fri',
  'weekday.sab': 'sat',
  'weekday.dom': 'sun',

  // error codes (reducer)
  'error.dead': 'dead',
  'error.gameOver': 'game over',
  'error.wrongLocation': 'action requires being at {location}',
  'error.closed': '{location} is closed',
  'error.noJob': 'job required',
  'error.noFood': 'no food at home',
  'error.noTargetJob': 'target job missing',
  'error.mustApplyNext': 'can only apply to the next role up',
  'error.lowEducation': 'insufficient education for {job}',
  'error.daysRequired': 'requires {needed} full day(s) at current role (you have {current})',
  'error.sameLocation': "you're already there",
  'error.alreadyHasSuit': 'you already have a suit',
  'error.noSuit': 'requires a suit (buy at the store) for {job}',
  'error.noMoney': 'not enough money',

  // hud
  'hud.day': 'Day',
  'hud.score': 'Score',
  'hud.location': 'Location ({hours})',

  // tabs
  'tab.travel': 'Travel',

  // stats
  'stat.energy': 'Energy',
  'stat.happiness': 'Happiness',
  'stat.hunger': 'Hunger',

  // meta
  'meta.job': 'Job',
  'meta.education': 'Education: {xp} XP — L{level} {levelName}',
  'meta.fridge.one': 'Fridge: {count} meal',
  'meta.fridge.other': 'Fridge: {count} meals',
  'meta.daysForPromotion': '({current}/{needed} days to {target})',
  'meta.hasSuit': '✓ Suit',

  // work warning
  'work.done': '✓ {start}-{end}h fulfilled ({hours}/{max}h core)',
  'work.willClearWarning': ' — warning will clear at midnight',
  'work.coreEndedWarn': '⚠ Only worked {hours}/{max}h core ({start}-{end}h). At midnight you get 1 warning',
  'work.coreEndedDemote': '⚠ Only worked {hours}/{max}h core ({start}-{end}h). At midnight you will be DEMOTED',
  'work.progress': 'Today: {hours}/{max}h core ({start}-{end}h) • work open {openLabel}',
  'work.warningPrefix': '⚠ You have 1 warning. ',

  // action button (candidatar-se)
  'action.applyLabel': 'Apply for {job} ({wage}/h{requirement})',
  'action.applyRequirement.one': ' • requires {days} day {previous}',
  'action.applyRequirement.other': ' • requires {days} days {previous}',

  // game over
  'gameover.titleDead': 'GAME OVER',
  'gameover.titleEnd': 'GAME COMPLETE',
  'gameover.reasonDead': "You didn't survive 30 days.",
  'gameover.reasonEnd': 'You completed 30 days.',
  'gameover.breakdown.money': 'Money',
  'gameover.breakdown.education': 'Education',
  'gameover.breakdown.happiness': 'Happiness',
  'gameover.breakdown.job': 'Job',
  'gameover.newGame': 'New game',

  // leaderboard
  'leaderboard.title': 'Leaderboard',
  'leaderboard.submitPrompt': 'Submit your score?',
  'leaderboard.namePlaceholder': 'Your name',
  'leaderboard.feedbackLabel': 'Feedback',
  'leaderboard.feedbackOptional': 'optional',
  'leaderboard.feedbackPlaceholder': 'What did you like? What can we improve?',
  'leaderboard.submit': 'Submit',
  'leaderboard.submitting': 'Submitting…',
  'leaderboard.checking': 'Checking if you make the top 100…',
  'leaderboard.skip': 'Skip',
  'leaderboard.invalidName': 'Name must be 3-24 chars (letters, numbers, _ - space)',
  'leaderboard.submitFailed': 'Submit failed: {reason}',
  'leaderboard.yourRank': 'Rank #{rank}',
  'leaderboard.viewAll': 'View leaderboard',
  'leaderboard.close': 'Close',
  'leaderboard.loading': 'Loading…',
  'leaderboard.empty': 'No scores yet — be the first!',
  'leaderboard.col.rank': '#',
  'leaderboard.col.name': 'Name',
  'leaderboard.col.score': 'Score',
  'leaderboard.turnstileMissing': 'Bot check pending — wait for the widget.',
  'leaderboard.error.rateLimited': 'Too many requests — wait a minute.',
  'leaderboard.error.turnstile': 'Bot check failed. Try again.',
  'leaderboard.error.duplicate': 'This game was already submitted.',
  'leaderboard.error.replay': 'Action log is invalid.',
  'leaderboard.error.dailyQuota': 'API reached the daily limit — try tomorrow.',
  'leaderboard.error.notFinished': 'You can only submit after the game ends.',
  'leaderboard.notQualified': "Score didn't make the top {size}.",

  // hours label
  'hours.always': '24h',
  'hours.range': '{open}h-{close}h',
};
